
// export enum InformationProvider {
//     PeoWithDisas = 'peoWithDisas',
//     Tutor = 'tutor'
//   }
export class DisabilitySurvey{
    id : number;
    //A THÔNG TIN CHUNG
        // Người cung cấp thông tin
        dayOfBirth: number;
        monthOfBirth: number;
        yearOfBirth: number;
        infoProvider : number;
        //họ tên
        fullName : string;
        //Ngày sinh
        dateOfBirth: any;
        //Giới tính
        gender: number;
        // dân tộc
        nationId: string;
        //
        folkId: number;
        // tỉnh/ tp
        provinceId: number;
        //quận huyện
        districtId: number;
        //xã phường
        wardId: number;
        //Giấy chứng nhận kt
        disDisabilityCertificateType: number;
        //Dạng khuyết tật
        typeOfDisabilityId: number;
        //Dạng khuyết tật khác
        typeOfDisabilityNote: string;
        //Mức độ
        levelId: number;
        //Được hỗ trợ giáo dục
        supportedEducation: boolean;
        //Tình trạng giáo dục
        educationalStatusId: number;
        //Nhập thông tin
        otherEducationalStatus: string;
        //Hình thức giáo dục
        studyModeId: number;
        //Đi học Lớp năm thứ
        studyingClassYear: string;
        //Bỏ học lớp năm thứ
        dropout: string;
        //lý do chưa đi học
        droppedOutNote: string;
        notYetLearnedNote: string;
        // đã hoàn thành cấp học
        completeSchoolLevelId: number;
        // đã hoàn thành trình độ đào tạo
        degreeTrainingId: number;
        // Tình trạng can thiệp list
        listStudentSurveyInterventionStatus: number[];
        // Tình trạng can thiệp
        interventioned: boolean;
        // Tình trạng can thiệp khác
        interventionNote: string;
        //Tình trạng việc làm
        employmentStatusId: number;
        //lý do, ngành nghề, mức thu nhật
        otherEmploymentStatus: string;
        //Tình trạng hôn nhân
        maritalStatusId: number;
        //đang sống tại
        caregiverId: number;
        //nơi khác
        caregiverNote: string;
        // điều kiện kinh tế gia đình
        livingConditionId: number;
        //Hình thức giáo dục:
        // studyModeId: number;
        //đã bỏ học lý do
        droppedOutClassYear: string;
        //Cấp học
        schoolLevelId: number;
        //Trình độ đào tạo
        qualificationId: number;
        notWorkingNote : string;
        quitJobNote : string;
        //nghề nghệp cụ thể
        particularJob : string;
        //tb thang
        averageIncome : number;
    //B. THÔNG TIN VỀ MỨC ĐỘ PHÁT TRIỂN
        //   mức độ phát triển
        levelOfDevelopmentId: number;
        //Loại của mức độ phát triển
        typeOfLevelOfDevelopmentId: number;
        //Thể chất
        physicalDev: number;
        //Nhận thức
        awarenessDev: number;
        //list
        listStudentSurveyLevelOfDevelopment: any[];
        //Ngôn ngữ giao tiếp
        colloquialDev: number;
        //Tự phục vụ
        selfService: number;
    //C. NHU CẦU HỖ TRỢ GIÁO DỤC
        // //Phương tiện hỗ trơ
        // educationFacilitiesEquipment: number;
        //nhu cầu
        needForSupportId: number;
        //nhu cầu
        listStudentSurveyEducationSupport: number[];
        //Can thiệp sớm
        earlyIntervention: number;
        //Phương tiện, thiết bị giáo dục
        educationFacilitiesEquipment: string;
        //Phương tiện hỗ trợ cá nhân
        personalVehicle : string;
        //Phục hồi chức năng
        sPRehabilitation: number;
        //Y tế
        sPMedical: number;
        // Bảo hiểm xã hội
        sPSocialOnsurance: number;
        // Học nghề
        apprenticeNote : number
        //other
        educationalSupportNote : string;
        //phương thức giáo dục
        modesOfEducationId: number;
        educationLevelId : number;
    //D. NHẬN THỨC VỀ CHÍNH SÁCH GIÁO DỤC NGƯỜI KHUYẾT TẬT
        //Biết chính sách GD cho nkt
        listStudentSurveyDisabilityPolicy: number[];
        understandDisabilityPolicy: boolean;
        //Biết chính sách GD cho nkt khác
        disabilityPolicyNote: string;
        //Tiếp nhận thông tin về chính sách nguồn
        listStudentSurveyInformationSource : number[];
        //Tiếp nhận thông tin về chính sách nguồn khác
        informationSourceNote : string;
        //Sự phối hợp của cộng đồng trong thực hiện chính sáhc giáo dục nkt
        communityCoordination: boolean;
        //Sự phối hợp của cộng đồng trong thực hiện chính sáhc giáo dục nkt chọn có
        communityCoordinationId: number;
        // sự phối hợp của chính quyền
        localGovernmentCoordination: boolean;
        //Sự phối hợp của cộng đồng trong thực hiện chính sáhc giáo dục nkt chọn có
        localGovernmentCoordinationId: number;
         //E Thông tin gia đình...............................................................................................
         /*1. Họ và tên người giám hộ*/
        tutorName : string;
         /*2. Giới tính*/
        tutorGender : number;
         /*3. Dân tộc*/
        tutorFolkId : number;
         /*4. Nghề nghiệp*/
        tutorCareer : string;
         /*5. Mối quan hệ với NKT*/
        tutorRelationshipId : number;
         /*6. Trình độ đào tạo*/
        tutorEducationLevelId : number
         /*7. Nhập khi chọn là 'Khác'*/
        tutorEducationLevelOther : string;
         // F. NHAN THUC VE CHINH SACH GIAO DUC NGUOI KHUYET TAT
         /*1. Biết chính sách GD cho người khuyết tật*/
        listStudentSurveyTutorDisabilityPolicy : any[]; 
        tutorUnderstandDisabilityPolicy : boolean;
         /*Chinh sach GD cho nguoi khuyet tat khac*/
        tutorDisabilityPolicyNote : string;
         /*2. Tiếp nhận thông tin về các chính sách*/
        listStudentSurveyTutorInformationSources : any[];
         /*Tiep nhan thong tin ve cac chinh sach nguon khac*/
        tutorInformationSourceNote : string;
         /*3. Sự phối hợp của cộng đồng trong thực hiện chính sách giáo dục cho người khuyết tật*/
        tutorCommunityCoordination : boolean;
        tutorCommunityCoordinationId : number;
         /*4. Sự phối hợp của chính quyền và ban, ngành địa phương*/
        tutorLocalGovernmentCoordination : boolean;
        tutorLocalGovernmentCoordinationId : number
 
         // G. KIEN THUC, KY NANG, CHAM SOC, HO TRO NGUOI KHUYET TAT
         /*1. Ông/bà đã được đào tạo/ bồi dưỡng về chăm sóc giáo dục và hỗ trợ người khuyết tật chưa?*/
         /*Chưa BD*/
        tutorUnfostered : boolean;
         /*Đào tạo bồi dưỡng về chăm sóc giáo dục và hỗ trợ - Loại*/
        studentSurveyTutorTrainingAndRetrainingTypes : any[]; 
         /*Đào tạo bồi dưỡng về chăm sóc giáo dục và hỗ trợ - Nội dung*/
        studentSurveyTutorTrainingAndRetrainings : any[];
         /*2. Đào tạo bồi dưỡng về kỹ năng chăm sóc người khuyết tật*/
        studentSurveyTutorSkillTypes : any[];
         /*3. Mong muốn của Ông/bà đối với người khuyết tật*/
        listStudentSurveyTutorEducationSupports : any[];
         /*Chon phuong thuc giao duc*/
        tutorModesOfEducationId : number;
         /*Phuong tien, thiet bi giao duc*/
        tutorEducationFacilitiesEquipment : string;
         /*Phuong tien ho tro ca nhan*/
        tutorPersonalVehicle : string;
         /*Hoc nghe*/
        tutorApprenticeNote : string;
         /*Ho tro khac*/
        tutorEducationalSupportNote : string;
        // list loại 
        listStudentSurveyTutorTrainingAndRetrainingTypes: any[];
        // list noi dung
        listStudentSurveyTutorTrainingAndRetrainings: any[];
        //noi dung khac
        tutorTrainingAndRetrainingNote: string;
        //ky nang 
        listStudentSurveyTutorSkillTypes: any[];
}

export class EducationalStatus{
    id: number;
    code: string;
    text: string;
}
